import { render, staticRenderFns } from "./listDesign.vue?vue&type=template&id=6bb039ae&scoped=true"
import script from "./listDesign.vue?vue&type=script&lang=js"
export * from "./listDesign.vue?vue&type=script&lang=js"
import style0 from "./listDesign.vue?vue&type=style&index=0&id=6bb039ae&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb039ae",
  null
  
)

export default component.exports